import axios from "axios";
import { LoadPanel, ScrollView, Toast } from "devextreme-react";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { handleGetLocal } from "../../../../services/auth-service";
import { seton_Save_Edit } from "../../../../reducer/participantNoteReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ColumnDropdown } from "../../../../components/Dropdownn";
import { logOut } from "../../../../components/Logout";
import { useNavigate } from "react-router-dom";
import { Table2 } from "../../../../components/Table2/Table2";
import { convertDateFormat } from "../../../../utils/date-helpers";
import { DynamicTabb } from "../../../../components/DynamicTab/DynamicTab";
import { Toster } from "../../../../components/Toster/Toster";
import { removeDynamicTab } from "../../../../reducer/HomePageReducer";

const DropDown = ({ dropDownData, setFields, fields, fieldNmae, rest, searchMode }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setFields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae].name}
        reset={rest}
        searchMode={searchMode}
      />
    </>
  );
};

const ResizableTextarea = ({ storageKey, style = {}, minHeight = 80, ...props }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    try {
      const savedSize = JSON.parse(localStorage.getItem(`enterAttendanceTextarea_${storageKey}`));

      if (savedSize?.height) {
        textarea.style.height = `${savedSize.height}px`;
      }

      if (savedSize?.width) {
        textarea.style.width = `${savedSize.width}px`;
      }
    } catch (error) {
      console.error("Unable to restore textarea size:", error);
    }

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      const { width, height } = entry.contentRect;

      localStorage.setItem(
        `enterAttendanceTextarea_${storageKey}`,
        JSON.stringify({
          width: Math.round(width),
          height: Math.round(height),
        }),
      );
    });

    resizeObserver.observe(textarea);

    return () => {
      resizeObserver.disconnect();
    };
  }, [storageKey]);

  return (
    <textarea
      ref={textareaRef}
      {...props}
      style={{
        minHeight: `${minHeight}px`,
        resize: "both",
        overflow: "auto",
        boxSizing: "border-box",
        ...style,
      }}
    />
  );
};

export const EnterAttendenceV2 = () => {
  const componentRef = useRef(null);
  const { user_data } = useSelector((store) => store.Home);
  const defaultFields = {
    // Attendance: {
    //     name: "Reported",
    //     id: "016F2C02-909F-EF11-882A-000D3A14ADC9",
    // },
    Attendance: {
      name: "",
      id: "",
    },
    ActivityNoteType: { name: "", id: "" },
    ArrearageReport: false,
    PreReportNote: "",
    SentenceNotes: user_data.sentanceNote,
    ActivityNoteTypeBottomText: "",
    BottomText: "",
    Tickets: false,
    Alcohol: false,
    Arrest: false,
    Firearms: false,
    Drugs: false,
    Weapons: false,
    Address: false,
    Phone: false,
    Employment: false,
  };

  const getInitialFields = () => {
    const saved = localStorage.getItem("attendanceFields");
    return saved ? JSON.parse(saved) : defaultFields;
  };

  const [fields, setFields] = useState(getInitialFields);
  // const [fields, setFields] = useState(defaultFields);
  const [AttendanceValidation, setAttendanceValidation] = useState("");
  const [ActivityNoteTypeValidation, setActivityNoteTypeValidation] = useState("");
  const [postnoteValidation, setpostnoteValidation] = useState("");

  const [addTest, setAddtest] = useState([]);
  const [addTestNoChangeof, setaddTestNoChangeof] = useState([]);
  const [activityNoteType, setactivityNoteType] = useState([]);
  const [attendance, setattendance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drugTestData, setDrugTestData] = useState([]);
  const { on_Save_Edit, resetReportDates } = useSelector((store) => store.participateNotes);
  const [showDrugTestSection, setShowDrugTestSection] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  const pathname = handleGetLocal("pathURL");

  const DrugTestTableColumn = [
    { title: "Served", customwidth: "110px" },
    { title: "Test Result", customwidth: "160px" },
    { title: "Result Date", customwidth: "120px" },
    { title: "Note", customwidth: "280px" },
  ];

  const setDrugTestTableColumnData = (data) => {
    const arr = [];
    data.map((val, i) => {
      arr.push({
        Served: convertDateFormat(val?.served),
        "Test Result": val?.testResult,
        "Result Date": convertDateFormat(val?.resultDate),
        Note: val?.note,
        ID: i,
      });
    });
    return arr;
  };

  const createAppointment = async (body) => {
    setLoading(true);
    const pathname = handleGetLocal("pathURL");
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/PersonReportDates/enter-attendance`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        dispatch(seton_Save_Edit(!on_Save_Edit));
        ResetValue();
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          message: "Successfully Added!",
          type: "success",
        });
        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
            message: "Successfully Added!",
            type: "success",
          });
        }, 1400);
        setLoading(false);
        // setenterAttendencePopup(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  // const onSave = () => {
  //     if (fields.ActivityNoteType && fields.Attendance && fields.ActivityNoteTypeBottomText) {
  //         setActivityNoteTypeValidation("");
  //         setAttendanceValidation("");
  //         setpostnoteValidation("");
  //         createAppointment({
  //             gReportDateScheduleId: user_data.gReportDateScheduleId,
  //             attendanceTypeId: fields.Attendance.id,
  //             activityNoteTypeId: fields.ActivityNoteType.id,
  //             note:
  //                 `${fields.ActivityNoteTypeBottomText}` +
  //                 (addTest.length > 1 ? ",Denies " + addTest.slice(1).join(", ") : "") +
  //                 (addTestNoChangeof.length > 1 ? ",No Change of " + addTestNoChangeof.slice(1).join(", ") : ""),
  //             arrearageRelated: fields.ArrearageReport,
  //         });
  //     } else {
  //         !fields.ActivityNoteType.id
  //             ? setActivityNoteTypeValidation("Please Select Activity Note Type")
  //             : setActivityNoteTypeValidation("");
  //         !fields.Attendance.id ? setAttendanceValidation("Please Select Attendance") : setAttendanceValidation("");
  //         !fields.ActivityNoteTypeBottomText ? setpostnoteValidation("Please Enter Note") : setpostnoteValidation("");
  //     }
  // };

  const onSave = async () => {
    const isValidActivityNoteType = fields.ActivityNoteType?.id?.trim();
    const isValidAttendance = fields.Attendance?.id?.trim();
    const isValidBottomText = fields.ActivityNoteTypeBottomText?.trim();

    if (isValidActivityNoteType && isValidAttendance && isValidBottomText) {
      setActivityNoteTypeValidation("");
      setAttendanceValidation("");
      setpostnoteValidation("");

      await createAppointment({
        gReportDateScheduleId: user_data.gReportDateScheduleId,
        attendanceTypeId: fields.Attendance.id,
        gPersonId: user_data.personId,
        activityNoteTypeId: fields.ActivityNoteType.id,
        note:
          `${fields.ActivityNoteTypeBottomText}` +
          (addTest.length > 1 ? ",Denies " + addTest.slice(1).join(", ") : "") +
          (addTestNoChangeof.length > 1 ? ",No Change of " + addTestNoChangeof.slice(1).join(", ") : ""),
        arrearageRelated: fields.ArrearageReport,
      });

      return true;
    } else {
      if (!isValidActivityNoteType) setActivityNoteTypeValidation("Please Select Activity Note Type");
      if (!isValidAttendance) setAttendanceValidation("Please Select Attendance");
      if (!isValidBottomText) setpostnoteValidation("Please Enter Report Date Note");
      return false;
    }
  };

  const getDropDown = async () => {
    setLoading(true);
    const pathname = handleGetLocal("pathURL");
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/PersonReportDates/masterDropdownValues`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setactivityNoteType(
          val.data.data.activityNoteType.map((vall) => {
            return { name: vall?.value, id: vall?.key };
          }),
        );

        setattendance(
          val.data.data.attendance.map((vall) => {
            return { name: vall?.value, id: vall?.key };
          }),
        );

        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  const drugTestVisible = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Account/getCompanyOption?Name=Drug Test Enabled`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      );
      console.log("response", response?.data?.data);
      setShowDrugTestSection(response?.data?.data.trim().toLowerCase() === "true");
    } catch (error) {
      console.error("Error fetching Drug Test Enabled option:", error);
    }
  };
  const getDrugTest = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/ReportDate/get-drug-test-pannel?gPersonID=${user_data.personId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setDrugTestData(setDrugTestTableColumnData(val?.data?.data));
        setLoading(false);
      })
      .catch((val) => {
        setLoading(false);
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status == 401) {
          logOut();
        }
      });
  };

  const ResetValue = () => {
    setFields({
      // Attendance: {
      //     name: "Reported",
      //     id: "e593a60f-3ff6-e011-98aa-00508d98a9ee",
      // },
      Attendance: { name: "", id: "" },
      ActivityNoteType: { name: "", id: "" },
      ArrearageReport: false,
      PreReportNote: "",
      SentenceNotes: user_data.sentanceNote ? user_data.sentanceNote : "",
      ActivityNoteTypeBottomText: "",
      BottomText: "",
      Tickets: false,
      Alcohol: false,
      Arrest: false,
      Firearms: false,
      Drugs: false,
      Weapons: false,
      Address: false,
      Phone: false,
      Employment: false,
    });
    localStorage.removeItem("attendanceFields");
    setActivityNoteTypeValidation("");
    setAttendanceValidation("");
    setpostnoteValidation("");
    setAddtest([]);
    setaddTestNoChangeof([]);
  };

  useEffect(() => {
    ResetValue();
  }, [resetReportDates]);

  useEffect(() => {
    localStorage.setItem("attendanceFields", JSON.stringify(fields));
    const savedFields = localStorage.getItem("attendanceFields");
    if (savedFields) {
      console.log("inside saved fields", savedFields);
    }
  }, [fields]);

  useEffect(() => {
    getDropDown();
    getDrugTest();
    drugTestVisible();
    const savedFields = localStorage.getItem("attendanceFields");
    if (savedFields) {
      console.log("inside saved fields", savedFields);

      setFields(JSON.parse(savedFields));
    }
  }, []);

  const handleCancel = () => {
    ResetValue();

    dispatch(removeDynamicTab(`/enterattendence/${user_data?.personId}`));

    navigate(`/participant/${user_data?.sOffenderNumber}`);
  };

  return (
    <>
      <DynamicTabb />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <div ref={componentRef} className="CreateAppointmentPopup" style={{ background: "white" }}>
        <div className="CreateAppointment_lower_block attendance-bottom-section">
          <div className="CreateAppointment_lower_block_left  attendance-options-section">
            <div
              className="drop_downn_block"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "32px", // space between Attendance and Activity Note Type
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <div>
                <p className="go-to-label-filed" style={{ width: "30%" }}>
                  Attendance
                </p>
                <DropDown
                  setFields={setFields}
                  fields={fields}
                  fieldNmae={"Attendance"}
                  dropDownData={attendance}
                  rest={setAttendanceValidation}
                  searchMode="startswith"
                />
                <p
                  style={{
                    color: "red",
                    fontWeight: "400",
                    position: "absolute",
                  }}
                >
                  {AttendanceValidation}
                </p>
              </div>
              <div>
                <p className="go-to-label-filed">
                  Activity Note Type <span>*</span>
                </p>
                <DropDown
                  setFields={setFields}
                  fields={fields}
                  fieldNmae={"ActivityNoteType"}
                  dropDownData={activityNoteType}
                  rest={setActivityNoteTypeValidation}
                  searchMode="startswith"
                />
                <p
                  style={{
                    color: "red",
                    fontWeight: "400",
                    position: "absolute",
                  }}
                >
                  {ActivityNoteTypeValidation}
                </p>
              </div>
              <label className="attendance-checkbox-label">
                <input
                  type="checkbox"
                  checked={fields.ArrearageReport}
                  onChange={(e) => {
                    setFields((previousFields) => ({
                      ...previousFields,
                      ArrearageReport: e.target.checked,
                    }));
                  }}
                />

                <span className="go-to-label-filed">Arrearage Related</span>
              </label>
            </div>
            <div className="drop_downn_block">
              <p className="go-to-label-filed">Pre-Report Note</p>
              <ResizableTextarea
                storageKey="preReportNote"
                value={user_data.preReportNote || ""}
                readOnly
                placeholder="Write note"
                style={{
                  height: "90px",
                  width: "100%",
                }}
              />
            </div>
            <div className="drop_downn_block">
              <p className="go-to-label-filed">Report Date Note</p>
              <ResizableTextarea
                storageKey="reportDateNote"
                value={fields.ActivityNoteTypeBottomText}
                onChange={(e) => {
                  setpostnoteValidation("");

                  setFields((previousFields) => ({
                    ...previousFields,
                    ActivityNoteTypeBottomText: e.target.value,
                  }));
                }}
                placeholder="Write note *"
                style={{
                  height: "90px",
                  width: "100%",
                }}
              />
              {/* <p
                                style={{
                                    color: "red",
                                    fontWeight: "400",
                                    position: "absolute",
                                }}
                            >
                                {postnoteValidation}
                            </p> */}
              {postnoteValidation && <p className="red-important-text">{postnoteValidation}</p>}
            </div>
          </div>
          <div className="CreateAppointment_lower_block_right" style={{ marginTop: "1.3%" }}>
            <p className="go-to-label-filed">Sentence Notes</p>
            <ResizableTextarea
              storageKey="sentenceNotes"
              value={user_data.sentanceNote || ""}
              readOnly
              placeholder="Write note"
              style={{
                height: "330px",
                width: "100%",
              }}
            />
          </div>
        </div>
        <div className="CreateAppointment_lower_block">
          <div className="CreateAppointment_lower_block_left" style={{ height: "fit-content" }}>
            <div style={{ marginTop: "2.5%" }} className="enterattendencesentencenode">
              <p className="go-to-label-filed">Denies</p>
              <div
                style={{
                  display: "flex",
                  marginTop: "-10px",
                  flexWrap: "wrap",
                }}
              >
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Tickets}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((previousFields) => ({
                        ...previousFields,
                        Tickets: isChecked,
                      }));

                      setAddtest((previousValues) => {
                        if (isChecked) {
                          const valuesWithoutTickets = previousValues.filter((item) => item !== "Tickets");

                          return valuesWithoutTickets[0] === "Denies"
                            ? [...valuesWithoutTickets, "Tickets"]
                            : ["Denies", ...valuesWithoutTickets, "Tickets"];
                        }

                        return previousValues.filter((item) => item !== "Tickets");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Tickets</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Alcohol}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Alcohol: isChecked,
                      }));

                      setAddtest((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Alcohol");
                          return arr[0] === "Denies" ? [...arr, "Alcohol"] : ["Denies", ...arr, "Alcohol"];
                        }

                        return prev.filter((item) => item !== "Alcohol");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Alcohol</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Arrest}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Arrest: isChecked,
                      }));

                      setAddtest((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Arrest");
                          return arr[0] === "Denies" ? [...arr, "Arrest"] : ["Denies", ...arr, "Arrest"];
                        }

                        return prev.filter((item) => item !== "Arrest");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Arrest</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Firearms}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Firearms: isChecked,
                      }));

                      setAddtest((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Firearms");
                          return arr[0] === "Denies" ? [...arr, "Firearms"] : ["Denies", ...arr, "Firearms"];
                        }

                        return prev.filter((item) => item !== "Firearms");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Firearms</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Drugs}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Drugs: isChecked,
                      }));

                      setAddtest((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Drugs");
                          return arr[0] === "Denies" ? [...arr, "Drugs"] : ["Denies", ...arr, "Drugs"];
                        }

                        return prev.filter((item) => item !== "Drugs");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Drugs</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Weapons}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Weapons: isChecked,
                      }));

                      setAddtest((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Weapons");
                          return arr[0] === "Denies" ? [...arr, "Weapons"] : ["Denies", ...arr, "Weapons"];
                        }

                        return prev.filter((item) => item !== "Weapons");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Weapons</span>
                </label>
              </div>
            </div>
            <div style={{ marginTop: "1.5rem" }} className="enterattendencesentencenode">
              <p className="go-to-label-filed">No Change of</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "72%",
                }}
              >
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Address}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Address: isChecked,
                      }));

                      setaddTestNoChangeof((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Address");
                          return arr[0] === "No Change of" ? [...arr, "Address"] : ["No Change of", ...arr, "Address"];
                        }

                        return prev.filter((item) => item !== "Address");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Address</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Phone}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Phone: isChecked,
                      }));

                      setaddTestNoChangeof((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Phone");
                          return arr[0] === "No Change of" ? [...arr, "Phone"] : ["No Change of", ...arr, "Phone"];
                        }

                        return prev.filter((item) => item !== "Phone");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Phone</span>
                </label>
                <label
                  className="flex-attendence"
                  style={{
                    marginBottom: "10px",
                    minWidth: "30%",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={fields.Employment}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setFields((prev) => ({
                        ...prev,
                        Employment: isChecked,
                      }));

                      setaddTestNoChangeof((prev) => {
                        if (isChecked) {
                          const arr = prev.filter((item) => item !== "Employment");
                          return arr[0] === "No Change of"
                            ? [...arr, "Employment"]
                            : ["No Change of", ...arr, "Employment"];
                        }

                        return prev.filter((item) => item !== "Employment");
                      });
                    }}
                  />

                  <span className="go-to-label-filed">Employment</span>
                </label>
              </div>
            </div>
            <div style={{ marginTop: "4%" }} className="enterattendencesentencenode">
              <div className="drop_downn_block">
                <ResizableTextarea
                  storageKey="deniesNoChangeSummary"
                  value={
                    (addTest.length > 1 ? `Denies ${addTest.slice(1).join(", ")}.` : "") +
                    (addTest.length > 1 && addTestNoChangeof.length > 1 ? "\n" : "") +
                    (addTestNoChangeof.length > 1 ? `No Change of ${addTestNoChangeof.slice(1).join(", ")}.` : "")
                  }
                  readOnly
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    height: "80px",
                    width: "100%",
                  }}
                />
              </div>
            </div>
          </div>
          {showDrugTestSection && (
            <div className="CreateAppointment_lower_block_right drug-test-section">
              <p style={{ marginBottom: "4%" }} className="go-to-label-filed">
                Drug Test
              </p>
              <div className="drop_downn_block">
                <ScrollView className="drug-test-scroll-view" height={300}>
                  <Table2
                    Tablecoloum={DrugTestTableColumn}
                    tableRow={drugTestData}
                    editTable={false}
                    load={false}
                    coloumWidthText={"Test Result"}
                    height={400}
                    mandatoryColoum={"served"}
                    showTotalBlock={false}
                    coloumchosser={true}
                    wordWrapEnabled={true}
                    mandatoryColoum={"Served"}
                  />
                </ScrollView>
              </div>
            </div>
          )}
        </div>
        <div className="popup_buttons" style={{ marginTop: "-20px" }}>
          <button
            // onClick={() => {
            //     onSave();
            //     dispatch(removeDynamicTab(`/enterattendence/${user_data?.personId}`));
            //     navigate(`/participant/${user_data?.sOffenderNumber}`);
            // }}
            onClick={async () => {
              const success = await onSave();
              if (success) {
                dispatch(removeDynamicTab(`/enterattendence/${user_data?.personId}`));
                navigate(`/participant/${user_data?.sOffenderNumber}`);
              }
            }}
            className="btn primary_btn"
          >
            Save
          </button>
          <button type="button" onClick={handleCancel} className="btn">
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};
